// extracted by mini-css-extract-plugin
export default {"container":"boldLine_container__Plvkw","bold":"boldLine_bold__diTcJ"};